import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DesignItem from '@/components/DesignItem';
import AddLocationModal from '@/features/design/components/AddLocationModal';
import LocationUpdateActionCard from '@/features/Scan/components/LocationUpdateActionCard';
import ScannedStylesListView from '@/features/Scan/components/ScannedStylesListView';
import { filterOutNotFoundItems, getViewTypeClass } from '@/features/Scan/utils';
import EmptyState from '@/features/trend-research/components/common/EmptyState';
import LocationScanActionCard from '@/features/Scan/components/LocationScanActionCard';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@/store/actions/DesignViewModalAction';

const ScanCount = ({ itemCount, onClearAll }) => (
	<div className="total-and-clear-content d-flex justify-content-between align-items-center mb-12">
		<p className="regular-14 gray_dark_01">
			Total Count: <span className="weight-500">{itemCount}</span>
		</p>
		<p className="regular-14 gray_dark_01 cursor-pointer" onClick={onClearAll}>
			Clear all
		</p>
	</div>
);

const ScannedStyles = ({
	viewType,
	handleRemoveItem,
	handleClearAll,
	fetchAllTags,
	productWiseTags,
	updateProductTagOnSelect,
	onAddTag,
	onUndoLocationUpdate,
	onSuccessLocationScanFromStyleScan = () => {},
	handleLocationUpdateSuccessFromLocationScan = () => {}
}) => {
	const [isShowLocationModal, setIsShowLocationModal] = useState(false);
	const [isShowLocationModalFromLocationScan, setIsShowLocationModalFromLocationScan] = useState(false);
	const {
		isUndo,
		scannedItems = [],
		locationUpdateResponse = {},
		locationResponseFromLocationScan = {}
	} = useSelector((state) => state.scanStore);
	const dispatch = useDispatch();

	const onCloseViewModal = () => {
		dispatch(clearDesignViewModalInfo({}));
	};

	const openDesignViewModal = (item) => {
		dispatch(
			setDesignViewModalInfo({
				id: item?.id,
				onCloseViewModal: onCloseViewModal,
				source: 'PRODUCT_LIST'
			})
		);
	};

	const filteredScannedItems = filterOutNotFoundItems(scannedItems);

	const designItemProps = {
		fromPage: 'SCAN',
		isShowCardTop: false,
		fetchAllTags,
		productWiseTags,
		updateProductTagOnSelect,
		isShowAddTag: false,
		isShowAddTagButton: viewType === 'LARGE_VIEW',
		onClickAddTag: onAddTag,
		isShowRemoveButton: true,
		onRemoveItem: handleRemoveItem
	};

	const renderDesignItem = (item, index) => (
		<DesignItem
			design={item}
			index={index}
			key={`design_${index}`}
			{...designItemProps}
			onClickDesignImage={() => openDesignViewModal(item)}
		/>
	);

	const renderStylesByViewType = () => {
		switch (viewType) {
			case 'LIST_VIEW':
				return (
					<ScannedStylesListView
						styles={scannedItems}
						onRemoveItem={handleRemoveItem}
						removeAll={handleClearAll}
						onOpenDesignView={openDesignViewModal}
					/>
				);
			case 'LARGE_VIEW':
			case 'NARROW_VIEW':
			default:
				return filteredScannedItems.map((item, index) => renderDesignItem(item, index));
		}
	};

	const gridViewClass = viewType !== 'LIST_VIEW' ? 'scan-grid-and-img-view' : '';
	const viewTypeClass = getViewTypeClass(viewType);
	const isShowScanCount = viewType !== 'LIST_VIEW' && filteredScannedItems.length > 0;
	const isShowLocationUpdateCard = Object.keys(locationUpdateResponse).length > 0 && !isUndo;
	const isShowLocationScanCard = Object.keys(locationResponseFromLocationScan).length > 0;

	return (
		<>
			{isShowScanCount && (
				<ScanCount itemCount={filteredScannedItems.length} onClearAll={handleClearAll} />
			)}
			{isShowLocationUpdateCard && (
				<LocationUpdateActionCard
					locationUpdateResponse={locationUpdateResponse}
					onUndoLocationUpdate={onUndoLocationUpdate}
					onShowLocationModal={setIsShowLocationModal}
				/>
			)}
			{isShowLocationScanCard && (
				<LocationScanActionCard
					locationResponseFromLocationScan={locationResponseFromLocationScan}
					onShowLocationModal={setIsShowLocationModalFromLocationScan}
				/>
			)}
			<div className={`${gridViewClass} ${viewTypeClass}`}>
				{scannedItems?.length > 0 ? (
					renderStylesByViewType()
				) : (
					<EmptyState title="No sample found. Scan your sample & location" />
				)}
			</div>

			{isShowLocationModal && Object.keys(locationUpdateResponse).length > 0 && (
				<AddLocationModal
					onClose={() => setIsShowLocationModal(false)}
					selectdLocationToEdit={{
						...locationUpdateResponse,
						isEdit: locationUpdateResponse?.isFound
					}}
					setShowAddLocationModal={setIsShowLocationModal}
					onSuccess={onSuccessLocationScanFromStyleScan}
				/>
			)}
			{isShowLocationModalFromLocationScan &&
				Object.keys(locationResponseFromLocationScan).length > 0 && (
					<AddLocationModal
						onClose={() => setIsShowLocationModalFromLocationScan(false)}
						selectdLocationToEdit={{
							...locationResponseFromLocationScan?.locationResponse,
							isEdit: locationResponseFromLocationScan?.locationResponse?.isFound
						}}
						setShowAddLocationModal={setIsShowLocationModalFromLocationScan}
						onSuccess={handleLocationUpdateSuccessFromLocationScan}
					/>
				)}
		</>
	);
};

export default ScannedStyles;
